<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="subcompany-page">
    <div class="page-header">
      <div class="page-header-text">
        <h1 class="page-title">Oddziały</h1>
      </div>
      <button
        class="action-pill action-pill--primary"
        @click="dialog = true; action = 'Tworzenie'; currentSubCompanyId = null"
      >
        <v-icon size="14">mdi-plus</v-icon>{{ $t('common.add') }}
      </button>
    </div>
    <v-data-table
      :headers="headers"
      :items="subCompanies"
      class="elevation-1"
      :loading="loading"
    >
      <template v-slot:top>
        <div class="table-section-title">
          <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-domain</v-icon></div>
          <div class="filter-title">{{ $t('subCompany.title') }}</div>
        </div>
      </template>
          <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoCompany(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
          <template v-slot:item.deleteSubCompany="{ item }">
            <v-btn class="error" @click="deleteSubCompany(item.id)"
              ><v-icon small class="pt-1">mdi-delete</v-icon></v-btn
            >
          </template>
    </v-data-table>
    <!-- Form Dialog -->
    <v-dialog content-class="dark-form-dialog" v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h6">{{ $t('subCompany.addTitle') }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
            <v-row>
              <!-- Name Field -->
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="formData.name"
                  :label="$t('common.name')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>

              <!-- Address Line 1 -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.addressLine1"
                  :label="$t('company.address')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>

              <!-- Address Line 2 (Optional) -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.addressLine2"
                  :label="$t('company.addressCont')"
                />
              </v-col>

              <!-- Zip Code -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.zipCode"
                  :label="$t('company.zipCode')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>

              <!-- City -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.city"
                  :label="$t('company.city')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>

              <!-- Country -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="formData.country"
                  :label="$t('company.country')"
                  :rules="[rules.required]"
                  required
                />
              </v-col>

              <!-- Tax Code (Optional) -->
              <v-col cols="12" md="6">
                <v-text-field v-model="formData.taxCode" :label="$t('company.taxCode')" />
              </v-col>

              <!-- Company Select (UUID) -->
              <!-- <v-col cols="12" md="6">
                <v-select
                  v-model="formData.companyId"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                  label="Select Company"
                  :rules="[rules.required]"
                  required
                />
              </v-col> -->
              <!-- Automatic Payouts Enabled -->
              <!-- <v-col cols="12" md="6">
                <v-switch
                  v-model="formData.automaticPayoutsEnabled"
                  label="Automatyczne Wypłaty"
                  disabled
                />
              </v-col> -->
              <v-col v-if="!currentSubCompanyId" cols="12">
                <v-checkbox
                  v-model="formData.assignToAll"
                  :label="$t('subCompany.assignToAll')"
                  :hint="$t('subCompany.assignToAllHint')"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Cancel Button -->
          <v-btn text color="secondary" @click="closeDialog">{{ $t('common.cancel') }}</v-btn>
          <!-- Submit Button -->
          <v-btn color="primary" @click="submitForm" :disabled="!valid || submitting" :loading="submitting">
            {{ $t('common.add') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
const axios = require("axios");
export default {
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      submitting: false,
      action: "",
      currentSubCompanyId: null,
      subCompanies: [],
      headers: [
        {
          text: "Nazwa",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "", value: "details", sortable: false },
        { text: "", value: "deleteSubCompany", sortable: false },
      ],
      formData: {
        name: "",
        addressLine1: "",
        addressLine2: "",
        zipCode: "",
        city: "",
        country: "",
        taxCode: "",
        automaticPayoutsEnabled: false,
        assignToAll: true,
      },
      companies: [
        // Example data - replace with your API data or state
        { id: "uuid-1234", name: "Company A" },
        { id: "uuid-5678", name: "Company B" },
        { id: "uuid-9012", name: "Company C" },
      ],
      rules: {
        required: (value) => !!value || "Wymagane.",
      },
    };
  },
  async created() {
    await this.initialize();
  },
  methods: {
    async toggleLoading(type) {
      const toggle = type;
      localStorage.setItem("loading", toggle);
      window.dispatchEvent(
        new CustomEvent("toggleLoading", {
          detail: {
            loading: localStorage.getItem("loading"),
            overlay: localStorage.getItem("loading"),
          },
        })
      );
    },
    async submitForm() {
      // Check if form is valid
      if (this.$refs.form.validate()) {
        if (this.submitting) return; // anty podwójny submit
        this.submitting = true;
        try {
          await this.toggleLoading(true);
          await axios({
            method: "post",
            url: process.env.VUE_APP_ROOT_API + "sub-company",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            data: {
              ...this.formData,
              id: this.currentSubCompanyId || undefined,
            },
          });
          this.closeDialog();
          await this.initialize();
        } catch (e) {
          console.log(e);
          Swal.fire("Błąd", e.response?.data?.message?.toString() || "Wystąpił błąd", "error");
        } finally {
          this.submitting = false;
          await this.toggleLoading(false);
        }
      }
    },
    async infoCompany(id) {
      await this.toggleLoading(true);
      try {
        const dep = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + "sub-company/" + id,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.formData = dep.data.data;
        this.currentSubCompanyId = dep.data.data.id;
        this.dialog = true;
        await this.toggleLoading(false);
      } catch (e) {
        await this.toggleLoading(false);
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
    },
    async deleteSubCompany(id) {
      Swal.fire({
        title: "Napewno usunąć?",
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tak",
        cancelButtonText: "Anuluj",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios({
              method: "delete",
              url: process.env.VUE_APP_ROOT_API + "sub-company/" + id,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            });
            await this.initialize();
          } catch (e) {
            console.log(e);
            Swal.fire("Błąd", e.response.data.message.toString(), "error");
          }
        }
      });
    },
    async initialize() {
      this.loading = true;
      try {
        const subCompanies = await axios({
          method: "get",
          url: process.env.VUE_APP_ROOT_API + `sub-company`,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });
        this.subCompanies = subCompanies.data.data.map((user) => {
          return {
            name: user.name,
            city: user.city,
            id: user.id,
          };
        });
      } catch (e) {
        console.log(e);
        Swal.fire("Błąd", e.response.data.message.toString(), "error");
      }
      this.loading = false;
    },

    closeDialog() {
      this.dialog = false;
      this.currentSubCompanyId = undefined;
      this.$refs.form.resetValidation(); // Reset form validation
    },
  },
};
</script>

<style scoped>
.subcompany-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { display: flex; align-items: flex-end; justify-content: space-between; gap: 12px; padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.action-pill { display: inline-flex; align-items: center; gap: 6px; background: #181C28; border: 1px solid rgba(255,255,255,0.08); color: #fff; padding: 8px 14px; border-radius: 10px; font-size: 12.5px; font-weight: 600; cursor: pointer; transition: transform 0.12s ease; font-family: inherit; }
.action-pill:hover { transform: translateY(-1px); border-color: rgba(255,255,255,0.18); }
.action-pill .v-icon { color: inherit !important; }
.action-pill--primary { background: #2962FF; border-color: #2962FF; box-shadow: 0 4px 12px rgba(41,98,255,0.3); }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; flex-grow: 1; }

.subcompany-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.subcompany-page >>> .v-card .v-card__title { color: #fff !important; padding: 16px 20px 8px !important; font-weight: 700 !important; font-size: 15px !important; }
.subcompany-page >>> .v-text-field--outlined fieldset, .subcompany-page >>> .v-select--outlined fieldset { border-color: rgba(255,255,255,0.1) !important; }
.subcompany-page >>> .v-text-field--outlined .v-input__slot, .subcompany-page >>> .v-select--outlined .v-input__slot { background: #181C28 !important; border-radius: 12px !important; }
.subcompany-page >>> .v-label { color: #6E7691 !important; }
.subcompany-page >>> .v-text-field input, .subcompany-page >>> .v-select__selection { color: #fff !important; }
.subcompany-page >>> .v-text-field:not(.v-text-field--outlined) input { color: #fff !important; }
.subcompany-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.subcompany-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.subcompany-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.subcompany-page >>> .v-data-table tbody tr { background: #232838 !important; }
.subcompany-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.subcompany-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.subcompany-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.subcompany-page >>> .v-data-table tbody td .v-btn.warning { background: rgba(255,152,0,0.18) !important; color: #FFB74D !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.subcompany-page >>> .v-data-table tbody td .v-btn.error { background: rgba(244,67,54,0.18) !important; color: #FF8A80 !important; border-radius: 8px !important; box-shadow: none !important; min-width: 36px !important; }
.subcompany-page >>> .v-data-table tbody td .v-btn .v-icon { color: inherit !important; }
.subcompany-page >>> .v-toolbar { background: transparent !important; color: #fff !important; }
.subcompany-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.subcompany-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.subcompany-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.subcompany-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.subcompany-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
